import { routesPaths } from './routes-paths';
import { i18n } from '../i18n';
import { IRoutePath } from '../types';
import { buttonIds } from './button-ids';

export const accountPaths: IRoutePath[] = [
  {
    path: routesPaths.MANAGEMENT_OVERVIEW,
    name: i18n.t('common.plans-overview'),
    logo: 'assets/shopping-bag.svg',
    id: buttonIds.planOverview,
  },
  {
    path: routesPaths.MANAGEMENT_BILLING,
    name: i18n.t('common.billing-details'),
    logo: 'assets/info.svg',
    id: buttonIds.billingDetails,
  },
  {
    path: routesPaths.MANAGEMENT_INVOICE,
    name: i18n.t('common.invoice-history'),
    logo: 'assets/file.svg',
    id: buttonIds.invoiceHistory,
  },
  {
    path: routesPaths.MANAGEMENT_USAGE,
    name: i18n.t('common.management-usage'),
    logo: 'assets/usage.svg',
    id: buttonIds.usage,
    hideHeader: true,
  },
];
